module.exports = __webpack_public_path__ + "static/media/twitch.4cd422b4.png";